import { TFunction } from 'next-i18next'
import { DocumentState, PurchaseDocument } from 'src/core/models'

export const buttonsList = (
  t: TFunction,
  document: PurchaseDocument,
  handleValidateCancelation: () => void,
  handleValidateRecept: () => void,
  handleValidateTax: () => void,
  handleValidateForwardFile: () => void,
  documentState: DocumentState
) => [

  { // Cancelation Props
    linkLabel: t('Transactions.DownloadCertificate'),
    link: document.cancellation_certificate,
    validateButtonLabel: t('Document.ValidateCertificate'),
    handleValidateButtonClick: handleValidateCancelation,
    isVisible: document.cancellation_certificate_is_valid === false,
    loading: (
      documentState.validateCancellation.loading &&
      documentState.validateCancellation.currentDocumentId === document.id
    )
  },

  { // Receipt Props
    linkLabel: t('Document.Invoice'),
    link: document.credit_offsetting_receipt,
    validateButtonLabel: t('Document.ValidateInvoice'),
    handleValidateButtonClick: handleValidateRecept,
    isVisible: document.credit_offsetting_receipt_is_valid === false,
    loading: (
      documentState.validateReceipt.loading &&
      documentState.validateReceipt.currentDocumentId === document.id
    )
  },

  { // Taxs Props
    link: document.tax_relief_document,
    linkLabel: t('Document.TaxDocument'),
    handleValidateButtonClick: handleValidateTax,
    validateButtonLabel: t('Document.ValidateTaxDocument'),
    isVisible: document.tax_relief_document_is_valid === false,
    loading: (
      documentState.validateTaxRelief.loading &&
      documentState.validateTaxRelief.currentDocumentId === document.id
    )
  },

  { // Carbon forward file
    link: document.carbon_forward_purchase_agreement_file,
    linkLabel: t('Download Carbon forward purchase agreement'),
    handleValidateButtonClick: handleValidateForwardFile,
    validateButtonLabel: t('Validate Carbon forward purchase agreement'),
    isVisible: !document.is_valid_carbon_forward_purchase_agreement_file && document.project_kind === 'carbon_forward',
    loading: (
      documentState.validateTaxRelief.loading &&
      documentState.validateTaxRelief.currentDocumentId === document.id
    )
  }
]
